import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { motion } from "framer-motion";

const StyledButton = ({ onClick, text, loading = false, disabled = false, startIcon, sx }) => {
  return (
    <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
      <Button
        onClick={onClick}
        variant="contained"
        disabled={disabled || loading}
        fullWidth
        startIcon={startIcon}
        sx={{
          py: 1.5,
          backgroundColor: 'primary.main',
          color: "white",
          fontWeight: 600,
          boxShadow: (theme) => theme.palette.mode === 'dark'
            ? '0px 4px 12px rgba(33, 150, 243, 0.3)'
            : '0px 4px 12px rgba(33, 150, 243, 0.2)',
          textTransform: "none",
          borderRadius: 2,
          '&:hover': {
            backgroundColor: 'primary.dark',
            boxShadow: (theme) => theme.palette.mode === 'dark'
              ? '0px 6px 20px rgba(33, 150, 243, 0.4)'
              : '0px 6px 20px rgba(33, 150, 243, 0.3)',
          },
          '&:disabled': {
            backgroundColor: 'action.disabledBackground',
            color: 'action.disabled',
          },
          ...sx
        }}
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          text
        )}
      </Button>
    </motion.div>
  );
};

export default StyledButton;